import { format, parse, toDate } from 'date-fns';
import { fr } from 'date-fns/locale';

let formatDate = (date, pattern) => {
  return format(date, pattern, {locale: fr});
};

// For calendar-only values (e.g. birth date) that have no meaningful time of day: parsing the raw API string
// (often midnight UTC) with `formatDate` shifts the displayed day for users behind UTC.
// Parse only the yyyy-MM-dd part as a local date so the calendar day never depends on the browser's timezone.
export let toCalendarDay = date => parse(String(date).slice(0, 10), 'yyyy-MM-dd', new Date());

export let formatDateOnly = (date, pattern) => {
  return format(toCalendarDay(date), pattern, {locale: fr});
};

// For dates carrying a timezone offset that are displayed as "Heure France Métropolitaine": format them in the
// Europe/Paris wall-clock time whatever the browser's timezone (DOM-TOM, abroad), instead of the browser's local time.
export let formatParisDate = (date, pattern) => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Paris',
    hourCycle: 'h23',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).formatToParts(toDate(date)).reduce((acc, {type, value}) => ({...acc, [type]: parseInt(value, 10)}), {});
  const parisDate = new Date(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
  return format(parisDate, pattern, {locale: fr});
};

export default formatDate;
